import { render } from "./CourseDetails.vue?vue&type=template&id=7e6bbe30&scoped=true"
import script from "./CourseDetails.vue?vue&type=script&lang=js"
export * from "./CourseDetails.vue?vue&type=script&lang=js"

import "./CourseDetails.vue?vue&type=style&index=0&id=7e6bbe30&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e6bbe30"]])

export default __exports__